module.exports = __webpack_public_path__ + "img/icon-xlsx.f3e0679e.svg";